import {
  Button,
  Typography,
  TypographyColor,
  TypographyVariant,
} from "../../core";
import { useStyles } from "./ErrorHandling.style";

export interface IErrorHandlingProps {
  type: ErrorType;
  onRefresh?: () => void;
}

export type ErrorType = "server" | "maintenance" | "network";
const errorContent: Record<ErrorType, { title: string; message: string }> = {
  server: {
    title: "We Are Having Issues",
    message:
      "We are having internal issues with our servers, please come back later.",
  },
  maintenance: {
    title: "Maintenance",
    message: "We're doing some maintenance, please come back later.",
  },
  network: {
    title: "Whoops!",
    message:
      "No internet connection! Make sure wifi or cellular data is turned on.",
  },
};

export const ErrorHandling: React.FC<IErrorHandlingProps> = ({
  type,
  onRefresh,
}) => {
  const classes = useStyles();
  const { title, message } = errorContent[type];

  return (
    <div className={classes.container}>
      <Typography
        variant={TypographyVariant.BodyB2Bold}
        color={TypographyColor.Secondary}
      >
        {title}
      </Typography>
      <Typography
        variant={TypographyVariant.BodyB5Regular}
        color={TypographyColor.Text2}
      >
        {message}
      </Typography>
      <Button size="small" onClick={onRefresh}>
        Refresh
      </Button>
    </div>
  );
};
